import { render } from "./ViewEnquiry.vue?vue&type=template&id=db0a3b0a&scoped=true"
import script from "./ViewEnquiry.vue?vue&type=script&lang=js"
export * from "./ViewEnquiry.vue?vue&type=script&lang=js"

import "./ViewEnquiry.vue?vue&type=style&index=0&id=db0a3b0a&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0a3b0a"]])

export default __exports__